const developMain = {
  title: 'ADVANCE UKRAINIAN DEFENCE WITH US',
  description:
    'We are looking for those who are keen to develop Ukrainian defense technologies, crave  innovative solutions for defenders, and are ready to drive our shared Victory forward.',
  button: {
    team: 'JOIN THE TEAM',
    partner: 'BECOME A PARTNER',
  },
}

export default developMain
